<script lang="ts">
  import Modal from '$lib/modals/Modal.svelte';
  import { removeItemFromCart } from '$lib/js/magento/cart/cart';
  import { storeCartItems, storeMiniCartModal, storeRemoveModal } from '$lib/js/stores';

  import { t } from 'svelte-i18n-lingui';

  async function removeProduct(prod_id: number) {
    $storeCartItems = $storeCartItems.filter((e) => {
      return e.item_id !== prod_id;
    });

    if($storeCartItems.length === 0) {
      $storeMiniCartModal = false
    }

    $storeRemoveModal = 0
    await removeItemFromCart(prod_id)
  }
</script>


<Modal on:close="{() => $storeRemoveModal = 0}" type="adapted">
  <div class="remove-modal">
    <div class="remove-modal__inner">
      <h2 class="title">{$t`Do you want to remove the product?`}</h2>
      <div class="remove-modal__buttons">
        <button class="remove" on:click="{() => $storeRemoveModal = 0}">{$t`Cancel`}</button>
        <button class="u-btn" on:click="{() => removeProduct($storeRemoveModal)}">{$t`Remove from cart`}</button>
      </div>
    </div>
  </div>
</Modal>


<style lang="scss">
  .remove-modal {
    max-width: 280px;

    &__inner {
      padding: 20px;
    }

    h2 {
      margin-right: 60px;
      font-size: 18px;
    }

    &__buttons {
      display: flex;
      justify-content: space-between;
      margin-top: 18px;

      button {
        &:first-child {
          margin-right: 6px;
        }
      }
    }
  }
</style>
